var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"about"}},[_c('div',{staticClass:"content project middle"},[_c('div',{staticClass:"cell"},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"sub-title text-center"},[_vm._v("About Us")])])])])])
}]

export { render, staticRenderFns }